<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智慧防疫轮播图 -->
    <EPBanner></EPBanner>
    <!-- 完整的智慧防疫业务流程 -->
    <EPBusiness></EPBusiness>
    <!-- 完善的智慧防疫设备 -->
    <EBEquipment></EBEquipment>
    <!-- 可靠的智慧防疫软件 -->
    <EBSoftware></EBSoftware>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import EPBanner from '../../../../components/pc/Programme/EpidemicPreventionComponents/EPBanner.vue'
import EPBusiness from '../../../../components/pc/Programme/EpidemicPreventionComponents/EPBusiness.vue'
import EBEquipment from '../../../../components/pc/Programme/EpidemicPreventionComponents/EBEquipment.vue'
import EBSoftware from '../../../../components/pc/Programme/EpidemicPreventionComponents/EBSoftware.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    EPBanner,
    EPBusiness,
    EBEquipment,
    EBSoftware,
  },
};
</script>

<style scoped>

</style>
